import ATMLoadProfileBaseController from '../common/atm_load_profile.base.controller'
import AppConstant from '../../../../../config/app.constants';

class ATMLoadProfileCreateController extends ATMLoadProfileBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        super();
        // super(Auth, $state, User, ATMLoadProfileService, Modal, $translate, $stateParams)
        this.$q = $q;
        this.User = User; 
        this.hasACL = {};

        this.defaultModel = {
            id: '',
            name: '',
            faceValue: '',
            currencyId: null,
            shiptypeId: null,
            icon: '',
            sortOrder: 1
        };
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() { }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    submit() { }
}

export default ATMLoadProfileCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/create/atm_load_profile.create.controller.js